module.exports = __webpack_public_path__ + "img/gd-fiori-calendar.96e9f890.png";